import { render, staticRenderFns } from "./ModalCadastraDisciplinaCompetencia.vue?vue&type=template&id=63550852"
import script from "./ModalCadastraDisciplinaCompetencia.vue?vue&type=script&lang=js"
export * from "./ModalCadastraDisciplinaCompetencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports